import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CmSharedModule} from '../shared/shared-module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {demandPartnerRoutes} from './demand-partner-app.route';
import {DemandPartnerAppComponent} from './demand-partner-app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {DemandPartnerMainComponent} from './demand-partner-main.component';
import {DemandPartnerResolver} from './demand-partner.resolver';
import {DpBlocklistComponent} from './blocklist/dp-blocklist.component';
import {DpDashboardComponent} from './dashboard/dp-dashboard.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {Principal} from '../shared/auth/principal.service';
import {AuthInterceptor} from '../shared/auth/auth.interceptor';
import { MatIconRegistry } from '@angular/material/icon';
import {DpStatsService} from './dp-stats.service';
import {DpSupportComponent} from './components/dp-support.component';
import {DpBlocklistTableComponent} from './blocklist/dp-blocklist-table.component';
import {DemandPartnerRequestDialogComponent} from './components/demand-partner-request-dialog.component';
import {DpStatsBlockedDomainsService} from './dp-stats-blocked-domains.service';
import {BlocklistAttachmentsDialogComponent} from '../shared/components/domain-specific/blocklist-attachments-dialog.component';
import {BlocklistAdTracesDialogComponent} from '../shared/components/domain-specific/blocklist-ad-traces-dialog.component';
import {HbCsvImportResultDialogComponent} from './components/hb-csv-import-result-dialog.component';
import {AuthModule} from '../shared/auth-module';
import {DpDashUnitsComponent} from './dashboard/ad-units/dp-dash-units.component';
import {DpDashSitesComponent} from './dashboard/sites/dp-dash-sites.component';
import {DpSiteApprovalApproveDialogComponent} from './dashboard/sites/dp-site-approval-approve-dialog.component';
import {DpSiteApprovalRejectDialogComponent} from './dashboard/sites/dp-site-approval-reject-dialog.component';
import {SitesCsvImportResultDialogComponent} from './components/sites-csv-import-result-dialog.component';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(demandPartnerRoutes,
            {
                useHash: true,
                // enableTracing: true  // <-- debugging purposes only
            }),
        CmSharedModule,
        AuthModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
    ],
    declarations: [
        DemandPartnerAppComponent,
        DemandPartnerMainComponent,
        DpBlocklistComponent,
        DpDashboardComponent,
        DpDashUnitsComponent,
        DpDashSitesComponent,
        DpSiteApprovalApproveDialogComponent,
        DpSiteApprovalRejectDialogComponent,
        DpSupportComponent,
        DpBlocklistTableComponent,
        DemandPartnerRequestDialogComponent,
        HbCsvImportResultDialogComponent,
        SitesCsvImportResultDialogComponent
    ],
    providers: [
        DemandPartnerResolver,
        MatIconRegistry,
        Principal,
        DpStatsService,
        DpStatsBlockedDomainsService,
        // PublisherResolver,
        DpBlocklistTableComponent,
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
    ],
    exports: [],
    entryComponents: [
        DemandPartnerRequestDialogComponent,
        BlocklistAttachmentsDialogComponent,
        BlocklistAdTracesDialogComponent,
        HbCsvImportResultDialogComponent,
        SitesCsvImportResultDialogComponent,
        DpSiteApprovalApproveDialogComponent,
        DpSiteApprovalRejectDialogComponent,
    ],
    bootstrap: [DemandPartnerAppComponent]
})
export class DemandPartnerAppModule {
}
